export const uk_valid_email_extensions = [
    'uky.edu',
    'ukhealthcare.uky.edu',
    'g.uky.edu',
    'mc.uky.edu',
    'law.uky.edu',
    'medicine.uky.edu',
    'dentistry.uky.edu',
    'nursing.uky.edu',
    'pharmacy.uky.edu',
    'engineering.uky.edu',
    'education.uky.edu',
    'cph.uky.edu',
    'ca.uky.edu',
    'finearts.uky.edu',
    'gws.uky.edu',
    'socialwork.uky.edu',
    'artsci.uky.edu',
    'business.uky.edu',
    'comm.uky.edu',
    'markey.uky.edu',
    'ibh.uky.edu',
    'ihs.uky.edu',
    'neuroscience.uky.edu',
    'transportation.uky.edu',
    'research.uky.edu',
    'cares.uky.edu',
    'chem.uky.edu',
    'cs.uky.edu',
    'math.uky.edu',
    'alumni.uky.edu',
    'hr.uky.edu',
    'lib.uky.edu',
    'admission.uky.edu',
    'housing.uky.edu',
    'police.uky.edu',
    'athletics.uky.edu'
    // Add more emails extensions here
];